// Common Footer.

import React from 'react';



export default () => {

    /*
    const [lang, setLang] = useState(Config.SERVICE_DEFAULT_LANGUAGE);
    const navigate = useNavigate();

    useEffect(() => {
        setLang(Util.get_url_lang());
    }, []);
    */



    return (
        <div style={{ width: '80%', height: '100px', position: 'fixed', bottom: '0', paddingTop: '11px', fontFamily: 'Roboto', fontSize: '11px', paddingLeft: '30px', textAlign: 'left', color: '#222222', lineHeight: '20px' }}>NSTRUCT Inc.<br />All rights reserved&copy;2018-2024</div>
    );

}